export default {
  ERROR_MESSAGES: {
    NULL_EVENT: 'Null event ignored',
  },
  EVENTS: {
    // 5 days in milliseconds
    TTL: 432000000,
  },
}
